import { Component } from '@angular/core';
import { CreditCardPayModel } from '../../models/creditCardPay.model';
import { InputSelectModel } from '../input-select/inputSelect.model';
import { Router } from '@angular/router';
import { CreditCardService } from '../../services/credit-card.service';
import { NotificationService } from '../../notification/swal/notification.service';
import Auth from '../../helpers/auth';
import { MaskHelper } from '../../helpers/mask';
import { Form } from '../../services/form';

@Component({
  selector: 'app-credit-card-single',
  templateUrl: './credit-card-single.component.html',
  styleUrls: ['./credit-card-single.component.less']
})

export class CreditCardSingleComponent extends Form {

  creditCard: CreditCardPayModel = new CreditCardPayModel();
  flags: Array<InputSelectModel> = new Array<InputSelectModel>();

  constructor(private router: Router, private creditCardService: CreditCardService, private notificationService: NotificationService) {
    super();
    this.flags.push(
      { title: 'Visa', value: '1'},
      { title: 'Mastercard', value: '2'},
      { title: 'Elo', value: '3'},
      { title: 'Amex', value: '4'},
      { title: 'Hipercard', value: '5'},
      { title: 'Discover', value: '6'},
      { title: 'Diners', value: '7'},
      { title: 'JCB', value: '8'},
      { title: 'Aura', value: '9'}
    );
  }

  private registerValidFields() {
    this.creditCard.cpf = Auth.getUser().cpf;
    this.creditCard.numero = MaskHelper.removeCreditCard(this.creditCard.number);
    this.creditCard.codigoSeguranca = this.creditCard.securityCode;
    this.creditCard.nome = this.creditCard.name;
    const expirationDate = MaskHelper.removeDate(this.creditCard.expirationDate);
    this.creditCard.monthExp = parseFloat(expirationDate.month);
    this.creditCard.yearExp = parseFloat(expirationDate.year);
    this.creditCard.mesAnoValidade = `${this.creditCard.monthExp}/20${this.creditCard.yearExp}`;
    this.creditCard.bandeira = parseFloat(this.creditCard.flag);
    this.creditCardService.register(this.creditCard)
      .then(() => {
        this.notificationService.showQuestionNotification('Cartão cadastrado com sucesso! Deseja realizar uma recarga?')
          .then((response) => {
            if (response.value) {
              this.router.navigate(['general/cartoesDependentes']);
            } else {
              this.router.navigate(['general/cartoes']);
            }
          });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message ? err.message : err.errors[0].messages[0]);
      });
  }

  registerCreditCard() {
    if (this.getFormStatus()) {
      this.registerValidFields();
    } else {
      this.notificationService.showErrorNotification('Todos os campos precisam estar válidos!');
    }
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/credit-card-single/credit-card-single.component.ts